@if (form) {

  <div class="flex align-items-center justify-content-center">
    <form class="edit-form mb-8" [formGroup]="form">

      <div class="flex flex-column mx-auto col-12">
        <div class="row">

          <div class="form-item field-wrapper flex align-items-center w-full mb-5">
            <p-float-label>
              <input pInputText
                     id="name"
                     class="gap-4"
                     formControlName="name"
                     maxlength="100"
                     required
                     [pKeyFilter]="ValidationUtils.NAME_PATTERN"
              />
              <label for="name" i18n>Name</label>
            </p-float-label>
          </div>

          <div class="form-item flex align-items-center w-full mb-5">
            <p-float-label>
                  <textarea pInputText
                            id="description"
                            class="gap-4"
                            formControlName="description"
                            maxlength="1000"
                            cols="50" rows="5"
                  ></textarea>
              <label for="description" i18n>Description</label>
            </p-float-label>
          </div>

          <div class="form-item field-wrapper flex align-items-center w-full mb-5">
            <p-float-label>
              <input pInputText
                     id="title"
                     class="gap-4"
                     formControlName="title"
                     maxlength="100"
                     [pKeyFilter]="ValidationUtils.TITLE_PATTERN"
              />
              <label for="title" i18n>Title</label>
            </p-float-label>
          </div>


          <div class="form-item flex align-items-center w-full mb-5">
            <p-float-label>
              <input pInputText
                     id="pageUrl"
                     class="gap-4"
                     formControlName="pageUrl"
                     maxlength="255"
                     required
              />
              <label for="pageUrl" i18n>URL</label>
            </p-float-label>
          </div>

          <div class="form-item flex align-items-center w-full flex-row mb-5 gap-4">
            <p-float-label>
              <input pInputText
                     id="displayOrder"
                     formControlName="displayOrder"
                     maxlength="10"
                     required
                     [pKeyFilter]="ValidationUtils.NAME_PATTERN"
              />
              <label for="displayOrder" i18n>Display Order</label>
            </p-float-label>

            <p-float-label>
              <input pInputText
                     id="expertCode"
                     formControlName="expertCode"
                     maxlength="10"
                     required
                     [pKeyFilter]="ValidationUtils.NAME_PATTERN"
              />
              <label for="expertCode" i18n>Expert Code</label>
            </p-float-label>
          </div>

          <div class="form-item flex align-items-center gap-4 mb-5">
            <label class="bold" for="locked" i18n>Locked</label>
            <p-toggle-switch id="locked" formControlName="locked"/>
          </div>

          <p-divider/>
          @if (groups?.length) {
            <h3>Assign Groups</h3>
            <p-pickList
              [source]="availableGroups"
              [target]="assignedGroups"
              formControlName="groups"
              sourceHeader="Available"
              targetHeader="Assigned"
              filterBy="displayName"
              sourceFilterPlaceholder="Search by name"
              targetFilterPlaceholder="Search by name"
              [showSourceControls]="false"
              [showTargetControls]="false"
              [dragdrop]="false"
              [responsive]="true"
              [stripedRows]="true"
              [sourceStyle]="{ height: '25rem' }"
              [targetStyle]="{ height: '25rem' }"
              (onMoveToSource)="sortGroups(availableGroups)"
              (onMoveToTarget)="sortGroups(assignedGroups)"
              breakpoint="1400px">
              <ng-template let-group pTemplate="item">
                    <span>
                      @if (group.displayName) {
                        {{ group.displayName }}
                      } @else {
                        {{ group.groupId }}
                      }
                    </span>
              </ng-template>
            </p-pickList>
          }

          <div class="flex flex-column my-2">
            @if (messageType) {
              @switch (messageType) {
                @case ('FORM_INVALID') {
                  <p-message severity="error" closable i18n>There are problems with your submission. Please address the fields highlighted in red</p-message>
                }
                @case ('ERROR_SAVING') {
                  <p-message severity="error" closable i18n>An error occurred while saving your changes. Please try again</p-message>
                }
                @case ('CHANGES_SAVED') {
                  <p-message severity="success" closable i18n>Your changes have been saved!</p-message>
                }
                @case ('NOT_UNIQUE') {
                  <p-message severity="error" closable i18n>A page already exists with that expert code. Please try another</p-message>
                }
                @case ('IN_USE') {
                  <p-message severity="info" closable i18n>This page is in use. Please remove uses of this page to continue</p-message>
                }
                @case ('NOT_EXISTS') {
                  <p-message severity="error" closable i18n>This page does not exist. It may have been deleted</p-message>
                }
                @case ('DELETION_CANCELLED') {
                  <p-message severity="info" closable i18n>Page has not been deleted</p-message>
                }
              }
            }
            <div class="form-buttons flex flex-row gap-4 justify-content-between align-items-center">
              @if (editing) {
                <button type="button"
                        class="p-button form-btn warning gap-2 delete" (click)="delete($event)" i18n>
                  Delete
                </button>
              }
              <button type="button"
                      class="p-button form-btn gap-2 save" (click)="save()" i18n>
                Save
              </button>

              <button type="button"
                      class="p-button form-btn secondary cancel gap-2"
                      (keydown.enter)="cancel()"
                      (click)="cancel()" i18n>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <p-confirmDialog/>
    </form>
  </div>
}
